(function () {
  var buyAgainStorageKey = "om2BuyAgainResultV1";

  function formatBuyAgainItemTitle(item) {
    var productTitle = item && item.title ? String(item.title) : "";
    var variantTitle =
      item && item.variant_title ? String(item.variant_title) : "";
    if (variantTitle) return productTitle + " - " + variantTitle;
    return productTitle || "Unavailable item";
  }

  async function addOrderItemsAgain(items) {
    var addedCount = 0;
    var failedItems = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i] || {};
      var requestedQty = Math.max(1, parseInt(item.quantity, 10) || 1);
      var itemTitle = formatBuyAgainItemTitle(item);
      if (!item.variant_id) {
        failedItems.push(itemTitle);
        continue;
      }
      var inventoryManaged = !!(
        item.inventory_management &&
        String(item.inventory_management).trim() !== ""
      );
      var inventoryPolicy = String(item.inventory_policy || "");
      var availableQty = parseInt(item.inventory_quantity, 10);
      if (isNaN(availableQty)) availableQty = 0;
      var inStock = item.available !== false;
      var stockInsufficient =
        inventoryManaged &&
        inventoryPolicy !== "continue" &&
        availableQty < requestedQty;
      if (!inStock || stockInsufficient) {
        failedItems.push(itemTitle);
        continue;
      }
      try {
        var response = await fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: item.variant_id,
                quantity: requestedQty,
                properties: {
                  _buy_again: "true",
                  _buy_again_selected: "true",
                },
              },
            ],
          }),
        });
        if (response.ok) {
          addedCount += requestedQty;
        } else {
          failedItems.push(itemTitle);
        }
      } catch (error) {
        failedItems.push(itemTitle);
      }
    }
    return { addedCount: addedCount, failedItems: failedItems };
  }

  function closeAllCardMenus(root, exceptWrap) {
    root.querySelectorAll("[data-om2-more-menu]").forEach(function (menu) {
      var wrap = menu.closest(".om2-more-wrap");
      if (exceptWrap && wrap === exceptWrap) return;
      menu.hidden = true;
      var trigger = wrap ? wrap.querySelector("[data-om2-more-trigger]") : null;
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    });
  }

  function initOrderActionsRoot(root) {
    if (!root || root.dataset.orderActionsV2Initialized === "true") return;
    root.dataset.orderActionsV2Initialized = "true";

    root.addEventListener("click", async function (e) {
      var moreTrigger = e.target.closest("[data-om2-more-trigger]");
      if (moreTrigger && root.contains(moreTrigger)) {
        e.preventDefault();
        var moreWrap = moreTrigger.closest(".om2-more-wrap");
        var moreMenu = moreWrap
          ? moreWrap.querySelector("[data-om2-more-menu]")
          : null;
        if (!moreMenu) return;
        var willOpen = moreMenu.hidden;
        closeAllCardMenus(root, willOpen ? moreWrap : null);
        moreMenu.hidden = !willOpen;
        moreTrigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
        return;
      }

      var buyAgainBtn = e.target.closest("[data-om2-buy-again]");
      if (buyAgainBtn && root.contains(buyAgainBtn)) {
        e.preventDefault();
        closeAllCardMenus(root);
        var itemsJson =
          buyAgainBtn.getAttribute("data-om2-buy-again-items") || "[]";
        var items = [];
        try {
          items = JSON.parse(itemsJson);
        } catch (error) {
          items = [];
        }
        buyAgainBtn.disabled = true;
        buyAgainBtn.setAttribute("aria-disabled", "true");
        var result = await addOrderItemsAgain(
          Array.isArray(items) ? items : [],
        );
        var failedItems = Array.isArray(result.failedItems)
          ? result.failedItems.filter(Boolean)
          : [];
        sessionStorage.setItem(
          buyAgainStorageKey,
          JSON.stringify({
            addedCount: result.addedCount,
            failedItems: failedItems,
            createdAt: Date.now(),
          }),
        );
        window.location.href = "/cart?buy_again=1";
        return;
      }

      var dialogBtn = e.target.closest("[data-om2-dialog]");
      if (dialogBtn && root.contains(dialogBtn)) {
        e.preventDefault();
        closeAllCardMenus(root);
        var id = dialogBtn.getAttribute("data-om2-dialog");
        if (!id || id.charAt(0) !== "#") return;
        var dialog = document.querySelector(id);
        if (dialog && typeof dialog.open === "function") dialog.open();
        return;
      }

      closeAllCardMenus(root);
    });

    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) closeAllCardMenus(root);
    });
  }

  /** 显示 toast 提示，3秒后自动收起 */
  function showTip(el, text) {
    if (!el) return;
    el.textContent = text;
    el.classList.add("om2-toast");
    setTimeout(function () {
      el.classList.remove("om2-toast");
    }, 3000);
  }

  function ensureContactSubmitHandler() {
    if (typeof window.ordersMainV2Submit === "function") return;

    window.ordersMainV2Submit = function (e) {
      // 始终阻止原生表单提交，改由 axios 接管
      e.preventDefault();

      var form = e.target;
      var dialog = form ? form.closest("ro-dialog") : null;
      var formTips = document.querySelector(".om2-form-tips");
      var url = form.getAttribute("data-action");
      var country = form.getAttribute("data-country") || "";
      var tipLimit =
        form.getAttribute("data-tip-limit") ||
        "You have submited one request. Please try later.";
      var tipSuccess =
        form.getAttribute("data-tip-success") ||
        "Submit Succeeds. We will reply to you soon. Please wait with patience.";

      // 重复提交保护：10 分钟内只允许提交一次，关闭弹窗后再显示 toast
      if (document.cookie.includes("submitted=")) {
        if (dialog && typeof dialog.close === "function") dialog.close();
        showTip(formTips, tipLimit);
        return;
      }

      // 表单验证：检查当前表单中的必填组件
      var requiredFields = form.querySelectorAll('ro-input[required], ro-select[required], ro-textarea[required]');
      var hasError = false;
      var firstErrorField = null;

      requiredFields.forEach(function (field) {
        if (typeof field.validate === "function") {
          var result = field.validate();
          if (!result.valid) {
            hasError = true;
            if (!firstErrorField) {
              firstErrorField = field;
            }
          }
        }
      });

      // 如果有验证失败的字段，阻止提交并聚焦到第一个错误字段
      if (hasError) {
        if (firstErrorField && typeof firstErrorField.focus === "function") {
          firstErrorField.focus();
        }
        return;
      }

      // 将 FormData 转为普通对象作为 JSON 请求体（排除 submit 按钮本身）
      var payload = {};
      new FormData(form).forEach(function (value, key) {
        if (key !== "submit") payload[key] = value;
      });

      // 提交期间禁用按钮，防止重复点击
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      axios
        .post(url, payload, {
          headers: {
            "Content-Type": "application/json",
            "X-Country": country,
          },
        })
        .then(function () {
          // 成功：写入防重复 cookie（10 分钟有效），关闭弹窗
          var exp = new Date();
          exp.setTime(exp.getTime() + 10 * 60 * 1000);
          document.cookie =
            "submitted=true;expires=" + exp.toUTCString() + ";path=/";
          showTip(formTips, tipSuccess);
          if (dialog && typeof dialog.close === "function") dialog.close();
        })
        .catch(function () {
          showTip(formTips, "Submit failed. Please try again later.");
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    };
  }

  function initOrderActionsV2() {
    document
      .querySelectorAll("[data-order-actions-root]")
      .forEach(initOrderActionsRoot);
    ensureContactSubmitHandler();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOrderActionsV2);
  } else {
    initOrderActionsV2();
  }
})();
